// eslint-disable-next-line
export const yandexMapsUrl = 'https://enterprise.api-maps.yandex.ru/2.1?apikey=5515ad91-9716-446f-bda6-60524961cc36&lang=ru_RU';
export const baloonMinDesktopHeight = 270;
export const baloonMinMobileHeight = 270;

export const TAKEAWAY_PICK_UP_POINT = 'pick_up_point';
export const TAKEAWAY_PARCEL_AUTOMAT = 'parcel_automat';
